module.exports = __webpack_public_path__ + "assets/asset_chart.a0fe8414.svg";